import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";

const SIG_IMG =
  "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400&ixlib=rb-4.1.0";

export default function Signature() {
  const { t } = useI18n();
  return (
    <section
      id="experience"
      className="relative w-full overflow-hidden"
      data-testid="signature-section"
    >
      <div className="relative h-[80svh] md:h-[90svh] w-full">
        <img
          src={SIG_IMG}
          alt="Organic luxury spa products on stone"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/30 to-black/70" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 h-full flex flex-col justify-end pb-16 md:pb-24 lg:pb-32 text-sand-50">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="block text-[10px] md:text-xs tracking-[0.4em] uppercase text-sand-300 mb-6"
          >
            — {t.signature.kicker}
          </motion.span>

          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="font-serif font-light leading-[1] tracking-tight text-4xl md:text-6xl lg:text-7xl max-w-4xl mb-10"
            data-testid="signature-title"
          >
            {t.signature.title}
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.25 }}
            className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 max-w-5xl"
          >
            <p className="md:col-span-6 text-base md:text-lg text-sand-50/85 leading-relaxed">
              {t.signature.p}
            </p>
            <p className="md:col-span-6 text-base md:text-lg text-sand-50/85 leading-relaxed italic font-serif">
              {t.signature.p2}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
